import { WhatsAppLocaleContent } from 'modules/templateEditor/common/types';
import { BADGE_VARIANTS } from 'ui/badge/constants';
import { WarningFill16 } from 'ui/icons/aurora/16px/WarningFill16';
import { HelpTooltip } from 'ui/tooltip/Variants';
import { InvertedWarningBadge, Wrapper } from './styles';
import { BadgeContent } from './types';

const BADGE_TEXT = 'Low quality';
const TOOLTIP_TEXT = 'is at risk of pause due to poor feedback or low engagement.';

type WhatsAppQualityBadgeProps = {
  numLocales: number;
  lowQualityLocales: WhatsAppLocaleContent[];
};

/**
 * Possible badge variations:
 *
 * Low quality: template has 1 locale and it has low quality
 * Low quality locale: template has multiple locales, 1 with low quality
 */
export const getBadgeContents = (
  numLocales: number,
  lowQualityLocales: WhatsAppLocaleContent[],
): BadgeContent => {
  const hasLanguageName = !!lowQualityLocales[0].languageName;

  return {
    badgeText: numLocales > 1 ? `${BADGE_TEXT} locale` : BADGE_TEXT,
    tooltipText: hasLanguageName
      ? `${lowQualityLocales[0].languageName} (${lowQualityLocales[0].locale}) ${TOOLTIP_TEXT}`
      : `${lowQualityLocales[0].locale} ${TOOLTIP_TEXT}`,
  };
};

export const WHATS_APP_LOW_QUALITY_BADGE_TEST_ID = 'whatsapp-low-quality-badge';

export const WhatsAppLowQualityBadge = ({
  numLocales,
  lowQualityLocales,
}: WhatsAppQualityBadgeProps) => {
  const { badgeText, tooltipText } = getBadgeContents(numLocales, lowQualityLocales);

  return (
    <InvertedWarningBadge
      data-test={WHATS_APP_LOW_QUALITY_BADGE_TEST_ID}
      icon={<WarningFill16 />}
      variant={BADGE_VARIANTS.INVERTED}
    >
      <Wrapper>
        <span>{badgeText}</span>
        <HelpTooltip
          automaticallyAvoidCollisions
          iconProps={{ height: 16, width: 16, isColorInherited: true }}
          tooltipContent={tooltipText}
        />
      </Wrapper>
    </InvertedWarningBadge>
  );
};
